
import React from "react";
import { Table, TableBody, TableCell, TableRow } from "../../../components/ui/table";
import { BusinessSession } from "../../../types/CustomerInterface";

interface businessSessionProps{
  businessSession?:BusinessSession
}


export const BusinessModelSection: React.FC<businessSessionProps> = ({businessSession }) => {
  const businessDetails = [
    { 
      label: "Industry", 
      value: businessSession?.industry
    },
    { 
      label: "About Company", 
      value:  businessSession?.about_company
    },
    { 
      label: "Business Model", 
      value: businessSession?.business_model
    }
  ];

  return (
    <section className="mb-6">
      <div className="flex items-center gap-3 mb-6">
        {/* <div className="w-8 h-8 bg-indigo-600 rounded-full flex items-center justify-center">
          <span className="text-white font-bold text-sm">2</span>
        </div> */}
        <h3 className="text-xl font-bold text-[#9e7926]">Business Model</h3>
      </div>

      <div className="bg-white rounded-lg border shadow-sm overflow-hidden">
        <Table className="break-inside-avoid-page">
          <TableBody>
            {businessDetails.map((detail, index) => (
              <TableRow key={index} className="hover:bg-gray-50">
                <TableCell className="font-medium bg-gray-50 w-1/4">{detail.label}</TableCell>
                <TableCell className="text-sm leading-relaxed whitespace-pre-line">
  {detail.value}
</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </section>
  );
};
